import { render, staticRenderFns } from "./AfterLogin.vue?vue&type=template&id=67809dc6"
import script from "./AfterLogin.vue?vue&type=script&lang=js"
export * from "./AfterLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports